export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const OFFER_PAGE_PATHS = ["/", "/go"];

export const isOfferPath = (pathname) => OFFER_PAGE_PATHS.includes(pathname);
